import React from 'react'
import Draggable from 'react-draggable'
import { Paper } from '@material-ui/core'

const PaperComponent = props => (
  <Draggable>
    <Paper {...props} />
  </Draggable>
)
export default PaperComponent
